import styled from 'styled-components';

export const StyledDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  justify-content: flex-end;
  .reject-button {
    margin-right: 20px;
  }
  .dropdown {
    margin-left: 0 !important;
    float: right;
    justify-content: flex-end;
    width: 100%;
  }
`;
